import type { Types } from '@fiverr-private/theme';
import type { AttachmentProps } from '../Attachment/types';

const fileTypes = {
    pdf: ['pdf'],
    document: ['doc', 'docx', 'xls', 'xlsx', 'csv', 'ppt', 'pptx', 'txt'],
    image: ['jpg', 'jpeg', 'png', 'gif', 'svg', 'bmp', 'tiff', 'heic', 'webp'],
    video: ['mp4', 'mov', 'avi', 'mkv', 'webm'],
    audio: ['mp3', 'wav', 'aac', 'ogg'],
};

export const getFileType = (name: string) => {
    const fileExtension = name.split('.').pop()?.toLowerCase();
    let fileType = 'other';

    for (const [type, extensions] of Object.entries(fileTypes)) {
        if (fileExtension && extensions.includes(fileExtension)) {
            fileType = type;
            break;
        }
    }

    return {
        isImage: fileType === 'image',
        isVideo: fileType === 'video',
        isPdf: fileType === 'pdf',
        isDocument: fileType === 'document',
        isAudio: fileType === 'audio',
        isOther: fileType === 'other',
    };
};

export const getSize = (
    variant: AttachmentProps['variant'],
    width: Types.ContainerProps['width'],
    height: Types.ContainerProps['height']
): Types.ContainerProps => {
    if (variant === 'list') {
        return {
            width: 44,
            height: 44,
        };
    }
    if (variant === 'grid') {
        return { width: 88, height: 88 };
    }

    return {
        width,
        height,
    };
};
